import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = 'url(#linear-gradient)',
  width = '100%',
  className = '',
  viewBox = '0 0 30 30',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="1.417"
        x2="0"
        y2="1.997"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#1c3fde" />
        <stop offset="0.428" stopColor="#ff3664" />
        <stop offset="1" stopColor="#feca50" />
      </linearGradient>
    </defs>
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M15,43.428A3.572,3.572,0,1,0,18.573,47,3.572,3.572,0,0,0,15,43.428Zm8.351-2.746a3.616,3.616,0,0,0-2.036-2.036c-1.406-.555-4.754-.431-6.315-.431s-4.905-.129-6.315.431a3.616,3.616,0,0,0-2.036,2.036C6.094,42.089,6.218,45.44,6.218,47s-.124,4.906.433,6.317a3.616,3.616,0,0,0,2.036,2.036c1.406.555,4.754.431,6.315.431s4.9.129,6.315-.431a3.616,3.616,0,0,0,2.036-2.036c.559-1.406.431-4.758.431-6.317s.129-4.906-.431-6.317ZM15,52.491a5.484,5.484,0,1,1,3.885-1.606A5.491,5.491,0,0,1,15,52.491Zm5.717-9.931a1.274,1.274,0,1,1,.908-.374,1.282,1.282,0,0,1-.908.374ZM26.786,32H3.214A3.214,3.214,0,0,0,0,35.214V58.786A3.214,3.214,0,0,0,3.214,62H26.786A3.214,3.214,0,0,0,30,58.786V35.214A3.214,3.214,0,0,0,26.786,32ZM25.639,51.42a6.371,6.371,0,0,1-1.731,4.487,6.375,6.375,0,0,1-4.487,1.731c-1.769.1-7.071.1-8.839,0A6.383,6.383,0,0,1,6.1,55.906,6.352,6.352,0,0,1,4.365,51.42c-.1-1.769-.1-7.072,0-8.839A6.351,6.351,0,0,1,6.1,38.094a6.386,6.386,0,0,1,4.487-1.726c1.769-.1,7.071-.1,8.839,0A6.376,6.376,0,0,1,23.908,38.1a6.375,6.375,0,0,1,1.731,4.49C25.739,44.351,25.739,49.649,25.639,51.42Z"
          transform="translate(0 -32)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
